import {
  API_URL,
  API_URL_STAGING,
  API_URL_DEVELOPMENT,
  SEGMENT_KEY,
  STRIPE_PUBLIC_KEY,
} from './constant';

/**
 * Build-time environment (e.g. "development", "staging", "production").
 * Note: in CRA, only REACT_APP_* vars are exposed to the browser bundle.
 */
export const REACT_APP_ENV = process.env.REACT_APP_ENV ?? 'production';

const DEFAULT_API_URL_BY_ENV = {
  production: API_URL,
  staging: API_URL_STAGING,
  development: API_URL_DEVELOPMENT,
};

// Choose API URL:
// 1) explicit override via REACT_APP_APIURL
// 2) otherwise based on REACT_APP_ENV
// 3) otherwise fall back to production URL
export const REACT_APP_APIURL =
  process.env.REACT_APP_APIURL ??
  DEFAULT_API_URL_BY_ENV[REACT_APP_ENV] ??
  API_URL;

// Prefer values from constants, otherwise fall back to hard-coded defaults
export const REACT_APP_SEGMENT_KEY =
  SEGMENT_KEY ?? 'a5SGCnPIOoAe0ppWmFGpqw90c63rLpI9';

// Choose Stripe key:
// 1) explicit override via env
// 2) otherwise from constants
export const REACT_APP_STRIPE_PUBLIC_KEY =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ?? STRIPE_PUBLIC_KEY;